import apiClient from "../apiClient";

const endpoint = "/api/game-types/";

export const getGameTypes = async () => {
  const response = await apiClient.get(endpoint);
  return response.data;
};

export const createGameType = async (data) => {
  const response = await apiClient.post(endpoint, data);
  return response.data;
};

export const updateGameType = async (id, data) => {
  const response = await apiClient.put(`${endpoint}/${id}`, data);
  return response.data;
};

export const deleteGameType = async (id) => {
  const response = await apiClient.delete(`${endpoint}/${id}`);
  return response.data;
};